import JRLogoWithText from './JRLogoWithText';

interface Props {
  selectedMarket: string;
  onMarketChange: (market: string) => void;
}

const markets = [
  { value: 'US', label: '美股' },
  { value: 'CN', label: 'A股' },
  { value: 'HK', label: '港股' },
];

/**
 * 移动端精简顶栏:Logo + 市场切换(CN/US/HK)。
 * 用户/退出/帮助等收进底部标签栏的「更多」抽屉。桌面端不渲染本组件(见 Layout)。
 */
export default function MobileTopBar({ selectedMarket, onMarketChange }: Props) {
  return (
    <header className="md:hidden bg-white border-b border-gray-100 shadow-sm sticky top-0 z-40">
      <div className="px-4 h-14 flex items-center justify-between">
        <JRLogoWithText logoSize={32} color="#1e40af" />
        <div className="flex items-center space-x-1.5 bg-gray-50 rounded-lg px-2.5 py-1.5 border border-gray-200">
          <i className="ri-global-line text-teal-600"></i>
          <select
            value={selectedMarket}
            onChange={(e) => onMarketChange(e.target.value)}
            className="bg-transparent border-none text-sm font-semibold text-gray-900 focus:outline-none cursor-pointer"
          >
            {markets.map((m) => (
              <option key={m.value} value={m.value}>{m.label}</option>
            ))}
          </select>
        </div>
      </div>
    </header>
  );
}
